import { useEffect } from "react";

const useUTMTracking = () => {
  useEffect(() => {
    const utmParams = new URLSearchParams(window.location.search);
    const utmSource = utmParams.get("utm_source");
    const utmMedium = utmParams.get("utm_medium");
    const utmCampaign = utmParams.get("utm_campaign");

    if (utmSource || utmMedium || utmCampaign) {
      gtag("event", "utm_redirect", {
        event_category: "Redirect",
        event_label: window.location.href,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
      });
    }
  }, []);
};

export default useUTMTracking;

declare const gtag: (...args: any[]) => void;
